import { render } from "./activityShops.vue?vue&type=template&id=63045d17&scoped=true"
import script from "./activityShops.vue?vue&type=script&lang=js"
export * from "./activityShops.vue?vue&type=script&lang=js"

import "./activityShops.vue?vue&type=style&index=0&id=63045d17&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63045d17"]])

export default __exports__